module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "id": "tsection"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.toggle) ? _c('div', {
    staticClass: "active-nav"
  }, [_c('div', {
    staticClass: "link shorthand"
  }, [_vm._l((_vm.navMain), function(navItem) {
    return _c('div', {
      staticClass: "small-div"
    }, [_c('a', {
      staticClass: "div-link",
      attrs: {
        "href": [navItem.section ? '/?anchor=' + navItem.section : navItem.path]
      },
      on: {
        "click": function($event) {
          [navItem.section ? _vm.onScrollTo($event, 'landing', navItem.section) : '']
        }
      }
    }, [_vm._v("\n          " + _vm._s(navItem.title) + "\n        ")])])
  }), _vm._v(" "), (false) ? _c('div', {
    staticClass: "small-div"
  }, [_c('div', [_c('a', {
    staticClass: "elink",
    attrs: {
      "href": ['mailto:' + _vm.navEmail]
    }
  }, [_vm._v(_vm._s(_vm.navEmail))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('div', {
    staticClass: "eicon"
  }, _vm._l((_vm.navSocial), function(navItem) {
    return _c('a', {
      staticClass: "fa",
      attrs: {
        "href": navItem.path,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa",
      class: ['fa-' + navItem.fa],
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.toggle) ? _c('div', {
    staticClass: "small-div"
  }, [_c('div', {
    staticClass: "eicon link-ticket-wrapper"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/bg_ribbon.svg"),
      "width": "200"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "href": "/tickets"
    }
  }, [_vm._v("\n                Purchase Tickets\n              ")])])])]) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "full-layer"
  }, [_c('navbar-full', {
    attrs: {
      "toggle": _vm.toggle
    },
    on: {
      "onToggle": function($event) {
        _vm.toggle = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b63b03a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarOverlay.vue
// module id = 935
// module chunks = 1